import { render } from "./Save.vue?vue&type=template&id=8fa39fcc"
import script from "./Save.vue?vue&type=script&lang=js"
export * from "./Save.vue?vue&type=script&lang=js"

import "./Save.vue?vue&type=style&index=0&id=8fa39fcc&lang=scss"
script.render = render

export default script